<template>
    <div :class="'footer '+$route.name">
        <div class="top">
            <a v-for="item in menu[ $core.getConfig().showMaintenance() ]" :href="'/#/'+item.id" :key="item.id"
               class="footer-link">
                {{ item.label }}
            </a>
        </div>
        <div class="bottom">
            powered by <strong>mp|ocs v10</strong>, {{ $core.getConfig().version }}<br/>
            &copy; {{ year }} Softwareentwicklung <strong>angerco</strong>.de
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data()
    {
        return {
            menu: {
                true:  [
                    {
                        id:    'contact',
                        label: 'Kontakt & Support'
                    },
                    {
                        id:    'privacy',
                        label: 'Datenschutz'
                    },
                    {
                        id:    'imprint',
                        label: 'Impressum'
                    } ],
                false: [
                    {
                        id:    'pricing',
                        label: 'Preise'
                    },
                    {
                        id:    'help',
                        label: 'Hilfe'
                    },
                    {
                        id:    'contact',
                        label: 'Kontakt & Support'
                    },
                    {
                        id:    'privacy',
                        label: 'Datenschutz'
                    },
                    {
                        id:    'imprint',
                        label: 'Impressum'
                    }
                ]
            }
        }
    },
    computed: {
        year()
        {
            return new Date().getFullYear()
        }
    }
}
</script>

<style scoped>

</style>